/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.piesync.bridge.rpc.AppsRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type AppResponse = {
  applicationListing?: ApplicationListingSimpleResponse;
  connectorName: string;
  appId: number;
  authInfo?: AuthInfo;
  displayName?: string;
  enabledForObjectRecommendation: Default<boolean>;
};

export type ApplicationListingSimpleResponse = {
  id: number;
  name: string;
  iconUrl?: string;
  extensionIconUrl?: string;
};

export type AppsResponse = { apps: Default<AppResponse[]> };

export type AuthInfo = { authenticatorId: string; scope?: string };

export type GetAppError = {
  reason: FailureReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type GetAppRequest = { appId: number };

export type GetAppResponse = { app: AppResponse };

export type FailureReason = 'APP_ID_NOT_FOUND' | unhandledEnumCase;

export type GetAllAppsResponseError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type GetAllResponseType = AppsResponse;
export type GetAllErrorType = GetAllAppsResponseError & HubspotMetadata;
export const getAllRpc: ChirpAvroRpcDetails<
  undefined,
  GetAllResponseType,
  GetAllErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AppsRpc',
  rpcName: 'getAll',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADPyoXw2hW7u-xBqVstM-Aa',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAppRequestType = Requestify<GetAppRequest>;
export type GetAppResponseType = GetAppResponse;
export type GetAppErrorType = GetAppError & HubspotMetadata;
export const getAppRpc: ChirpAvroRpcDetails<
  GetAppRequestType,
  GetAppResponseType,
  GetAppErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AppsRpc',
  rpcName: 'getApp',
  auth: 'app',
  fingerprint: 'KPFzaoVrp822byeq4IG5AyrM0ULITvWP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
